import React, { forwardRef } from "react";
import PhoneInput from 'react-phone-input-2';
import "../../theme-vars.css";
import { styled } from "@mui/material/styles";

type Props = {
  title: string;
  style?: React.CSSProperties;
  validator?: (value: string) => string;
  length?: boolean;
  disabled?: boolean;
  value?: string;
  required?: boolean;
  country?: string;
  phoneNumber?: string;
  handlePhoneChange?: (phone: string, country?: any) => void;
};

const primaryColor = "#292744";
const PhoneInputWrapper = styled("div")({
  position: 'relative',
  '& .form-control': {
    width: "100% !important",
    borderRadius: 12,
    backgroundColor: "#f9fafb",
    fontSize: "var(--font-size-medium)",
    fontFamily: "var(--font-family-main)",
    color: "#222",
    boxSizing: 'border-box',
    height: '50px',
    lineHeight: '50px',
    padding: '0 14px 0 48px',
    // border: '1.5px solid #bfc7d5',
    transition: 'border 0.2s',
  },
  '& .form-control:focus': {
    border: `1.5px solid ${primaryColor}`,
    boxShadow: "none",
  },
  '& .special-label': {
    display: 'none',
  },
  '& .country-list': {
    position: 'fixed',
  },
});

const PhoneNumberWrapper = forwardRef<HTMLInputElement, Props>(
  ({ title, style, validator, length, disabled, value, required, handlePhoneChange, country, phoneNumber }, ref) => {

    // Add custom styles for flag dropdown and selected flag
    const customFlagStyles = `
      .react-tel-input .flag-dropdown.open .selected-flag,
      .react-tel-input .selected-flag:hover,
      .react-tel-input .selected-flag:focus {
        background: none !important;
      }
    `;

    return (
      <div style={{ position: 'relative', width: '100%' }}>
        <style>{customFlagStyles}</style>
        <label style={{
          position: 'absolute',
          top: '-9px',
          left: '11px',
          background: '#f7f8fa',
          padding: '0 4px',
          fontSize: '12px',
          color: '#555',
          fontFamily: 'var(--font-family-main)',
          zIndex: 2
        }}>
          {title} <span style={{ color: '#d32f2f' }}>{required ? '*' : ''}</span>
        </label>
        <PhoneInputWrapper>
          <PhoneInput
            country={country || 'in'}
            value={value || ''}
            onChange={handlePhoneChange}
            placeholder={title}
            inputProps={{
              type: 'tel',
              autoComplete: 'tel',
              name: 'phone',
              style: { fontFamily: 'var(--font-family-main)' },
              disabled: disabled // only input disabled
            }}
            inputStyle={{
              background: '#f9fafb',
              width: '100%',
              fontSize: 'var(--font-size-medium)',
              fontFamily: 'var(--font-family-main)',
              color: '#222',
              padding: '0 14px 0 48px',
              borderRadius: 12,
              boxSizing: 'border-box',
              // height: '48px',
              lineHeight: '48px',
            }}
            containerStyle={{
              // height: '48px', 
              borderRadius: 12,
              background: '#f9fafb',
              border: 'none',
              boxSizing: 'border-box',
              display: 'flex',
              alignItems: 'center',
              fontSize: 'var(--font-size-medium)',
              fontFamily: 'var(--font-family-main)',
            }}
            buttonStyle={{ border: 'none', background: 'transparent' }}
            dropdownStyle={{ borderRadius: 12 }}
            disableDropdown={false}
            enableSearch={true}
            masks={{ in: '..........' }}
          />
        </PhoneInputWrapper>
      </div>
    );
  }
);

export default PhoneNumberWrapper;
